/*
 * @Description: 视频控件
 * @Author: wangsx
 * @Date: 2020-07-08 21:46:31
 * @LastEditors: your name
 * @LastEditTime: 2022-01-22 14:28:47
 */

import CheckVideo from "./module/checkVideo";
import Camera from "./module/Camera";
import Talk from "./module/Talk";
import Broadcast from "./module/Broadcast";

import {
  request,
  response,
  onMsgEvent,
  offMsgEvent,
  socket,
  socketInit
} from "./utils/request";
import mix from "./utils/mix";
// 常量定义
import { CLIENT_KEY } from "./utils/constant";

// 全局对象
let clientShowState = false; // 控件显示状态
const eventCache = new Set(); // 事件缓存

/**
 * @Description: 视频控件
 */
class Client extends mix(CheckVideo, Camera, Talk, Broadcast) {
  connected = false; // 是否已连接
  isFullScreen = false; // 最大化状态
  visibility = true; //
  /**
   * 连接视频客户端
   * @param address 连接地址（可选，默认连接config配置文件中的地址）
   */
  connect(address) {
    socketInit(address);
  }

  // websocket事件，提供给外部实现处理
  onOpen() {}

  onClose() {}
  onError() {}
    /**
     * 注册消息监听
     * @param {*} msgType 消息类型
     * @param {*} callback 处理函数
     */
  on(msgType, callback) {
    onMsgEvent(msgType, callback);
  }

  /**
   * 注销消息监听
   * @param {*} msgType 消息类型
   * @param {*} callback 处理函数
   */
  off(msgType, callback) {
    offMsgEvent(msgType, callback);
  }

  // 缓存控件事件
  eventCacheFn(fn, params) {
    if (!client.connected) {
      eventCache.add({
        fn: fn,
        params: params || null
      });
      return true;
    }
    return false;
  }

  /**
   * @Description: 设置用户信息
   * {
    "organId":"1",
    "userName":"",
    "ftpIp":"10.73.95.205",
    "ftpPort":"8989",
    "ftpPath":"VideoFtpServer/video",
    "ftpUser":"administrator",
    "ftpPassword":"Huawei@123"
  * }
  */
  setUser(reqBody) {
    const data = {
      ftpPath: "VideoFtpServer/video"
    };
    reqBody = Object.assign(reqBody, data);
    return new Promise((resolve, reject) => {
      request("SetUser", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * 设置弹框的显示隐藏
   * @param {*} v
   */
  setDialogVisible(v) {
    if (v) {
      client.videoState().then(res => {
        if (res.returnValue && res.returnValue.ShowState) {
          clientShowState = res.returnValue.ShowState;
          client.hide().then(res => {
            console.log(res);
          });
        } else {
          clientShowState = false;
        }
      });
    } else {
      if (clientShowState) {
        client.show();
      }
    }
  }

  /**
   * 监听浏览器tab切换
   * @param {*} event
   */
  visibilityChange() {
    console.log(
      "%c [ 监听浏览器tab切换 ]",
      "font-size:13px; background:pink; color:#bf2c9f;"
    );

    const self = this;

    function visibilityChange() {
      self.visibility = document.visibilityState !== "hidden";
      if (!self.visibility) {
        if (!self.isFullScreen) {
          self.hide("visibility");
        }
      } else {
        self.show();
        self.handleHideCacheCamera();
      }
    }
    document.addEventListener("visibilitychange", visibilityChange);
    window.onbeforeunload = function(e) {
      /// /监听地址切换事件
      e = window.event || e;
      client.maximizedRecovery();
      client.hide();
    };
  }

  /**
   * @Description: 关闭控件
   */
  close() {
    return new Promise((resolve, reject) => {
      request("Close", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取控件版本号
   */
  version() {
    return new Promise((resolve, reject) => {
      request("Version", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 获取本地麦克风列表
   */
  getLocalMikeList() {
    return new Promise((resolve, reject) => {
      request("GetLocalMikeList", null, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 使用麦克风开始录音
   * {
   *  @param {String} CameraName 摄像头名称
   *  @param {String} VideoFileName 保存的文件名称
   * }
   */
  localAudioCollect(reqBody) {
    return new Promise((resolve, reject) => {
      request("LocalAudioCollect", reqBody, {
        resolve,
        reject
      });
    });
  }

  /**
   * @Description: 停止录音
   */
  localStopCollect() {
    return new Promise((resolve, reject) => {
      request("LocalStopCollect", null, {
        resolve,
        reject
      });
    });
  }
}

// window.__videoClient = client;
const client = new Client();

// 最大化还原
client.on("MaximizedRecovery", e => {
  client.isFullScreen = false;
});

/**
 * 连接成功事件
 */
function onOpen(event) {
  if (!client.connected) {
    client.connected = true;
    window.localStorage.setItem("videoConnected", true);
    // 处理缓存事件
    if (eventCache.size > 0) {
      eventCache.forEach(item => {
        item.fn(...item.params);
      });
      eventCache.clear();
    }
  }
  console.log("onOpen ->   client.connected ", client.connected);
  client.onOpen();
  console.log("视频客户端连接成功");
}

/**
 * 连接关闭事件
 */
function onClose(event) {
  client.connected = false;
  client.onClose();
  console.log("视频客户端连接失败");
}

/**
 * 连接失败事件
 */
function onError(event) {
  client.connected = false;
  client.onError();
  if (socket.reconnectAttemptCount >= 1) {
    client.checkVideoControl(() => {
      // 连接视频客户端
      client.connect("ws://127.0.0.1:4502");
    });
  }
  console.log(
    "视频客户端连接异常，可能问题：1.视频客户端未启动; 2.视频客户端连接地址错误;"
  );
}

// 注册事件
socket.on("onmessage", CLIENT_KEY, response);
socket.on("onopen", CLIENT_KEY, onOpen);
socket.on("onclose", CLIENT_KEY, onClose);
socket.on("onerror", CLIENT_KEY, onError);
// 监听浏览器tab切换
client.visibilityChange();
// 连接视频客户端
// client.connect("ws://127.0.0.1:4502");

// // ES6模块写法
export default client;